import {Button} from '@mantine/core';
import {AiOutlineClear} from 'react-icons/ai';

import {useCleanupMigratedPipelineMutation} from '../hooks/usePipelinesQuery';
import {usePipelines} from '../hooks/usePipelines';
import {usePipelinesSelection} from '../hooks/usePipelinesSelection.ts';


export const CleanupMigratedButton = () => {

    const cleanupMigratedPipelineMutation = useCleanupMigratedPipelineMutation();
    const {items: pipelines} = usePipelines();

    const {
        selection,
        handleClearSelection,
    } = usePipelinesSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const selectedPipelines = pipelines.filter(p => recordIds.includes(p.id));
    const disabled = recordIds.length === 0 || !selectedPipelines.every(p => p.pipelineStatus === 'MIGRATED_PENDING_CLEANUP');

    const handleCleanup = async () => {
        for (const id of recordIds) {
            await cleanupMigratedPipelineMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (
        <Button
            disabled={disabled}
            onClick={handleCleanup}
            loading={cleanupMigratedPipelineMutation.isPending}
            leftSection={<AiOutlineClear/>}
        >
            Cleanup
        </Button>
    );

};
